import { EventType, FailureContext, generateEventTypeMapDefaults, WorkflowEventEventTypeMap, WorkflowEventMetaDataMapWithDefaults } from '@aiwyn/shared';

/**
 * Flow 10 — Applying Credits.
 * The user applies available account credits against outstanding invoices.
 *
 * The submit funnel follows the SUBMITTED + SUCCEEDED + FAILED triad. Terminals carry
 * `operationDurationMs`; FAILED metadata extends `FailureContext`.
 */
export enum CreditApplicationWorkflowEvent {
  CREDIT_APPLICATION_STARTED = 'CREDIT_APPLICATION_STARTED',
  CREDIT_APPLICATION_INVOICES_SELECTED = 'CREDIT_APPLICATION_INVOICES_SELECTED',
  CREDIT_APPLICATION_SUBMITTED = 'CREDIT_APPLICATION_SUBMITTED',
  CREDIT_APPLICATION_SUBMIT_SUCCEEDED = 'CREDIT_APPLICATION_SUBMIT_SUCCEEDED',
  CREDIT_APPLICATION_SUBMIT_FAILED = 'CREDIT_APPLICATION_SUBMIT_FAILED',
  CREDIT_APPLICATION_CANCELLED = 'CREDIT_APPLICATION_CANCELLED',
}

export type CreditApplicationWorkflowEventMetaDataMap = WorkflowEventMetaDataMapWithDefaults<
  CreditApplicationWorkflowEvent,
  {
    [CreditApplicationWorkflowEvent.CREDIT_APPLICATION_INVOICES_SELECTED]: { invoiceCount: number; totalAmount: number };
    [CreditApplicationWorkflowEvent.CREDIT_APPLICATION_SUBMITTED]: { totalAmount: number };
    [CreditApplicationWorkflowEvent.CREDIT_APPLICATION_SUBMIT_SUCCEEDED]: { totalAmount: number; operationDurationMs: number };
    [CreditApplicationWorkflowEvent.CREDIT_APPLICATION_SUBMIT_FAILED]: FailureContext & { totalAmount: number; operationDurationMs: number };
  }
>;

export const CreditApplicationEventEventTypeMap: WorkflowEventEventTypeMap<CreditApplicationWorkflowEvent> = {
  ...generateEventTypeMapDefaults(CreditApplicationWorkflowEvent, EventType.USER),
  [CreditApplicationWorkflowEvent.CREDIT_APPLICATION_SUBMIT_SUCCEEDED]: EventType.SYSTEM,
  [CreditApplicationWorkflowEvent.CREDIT_APPLICATION_SUBMIT_FAILED]: EventType.ERROR,
};
